import request from '../nasm_sdk_v2/request';

export default function muscleGroups(apiVer) {
  function getList(apiVersion = apiVer) {
    return request.get(`${apiVersion}/api/muscle-groups`);
  }

  return { getList };
}